import jsPDF from "jspdf";
import { CSVLink } from "react-csv";

import { format } from 'date-fns';

const generateReporteEstudiantesExcel = (estudiantes) => {
    let tableRows = [];
    let i = 0;
    estudiantes.forEach((estudiante) => {
        i += 1;
        let dateTemp = new Date(estudiante.fecha_agenda);
        if (dateTemp === 'Invalid Date')
            dateTemp = 'fecha incorrecta'
        else
            dateTemp = format(dateTemp.setDate(dateTemp.getDate() + 1), "MMM dd, yyyy")
        
        let dateTemp2 = new Date(estudiante.fecha);
            if (dateTemp2 === 'Invalid Date')
                dateTemp2 = 'fecha incorrecta'
            else
                dateTemp2 = format(dateTemp2.setDate(dateTemp2.getDate() + 1), "MMM dd, yyyy")

        let tempData  = 
            {   "Nro":i,
                "Codigo":estudiante.cli_id,
                "Nombres":estudiante.cli_apellido + ' ' + estudiante.cli_nombre,
                "Agendado":dateTemp,
                "Telefono":estudiante.cli_telefono,
                "Especialidad":estudiante.esp_nombre,
                "Ult. comentario":estudiante.comentario,
                "Fec. ult. comentario": dateTemp2
            };
        
        tableRows.push(tempData);
        
    });

    return tableRows;

};

export default generateReporteEstudiantesExcel;
